import { compressedImageUrl } from '../design-system';

// The winner card's <Image> params (see WinnerContent). Preloads MUST pass the
// EXACT same values so the warmed CDN URL matches the one the card requests —
// otherwise the card re-downloads on reveal and pops in a beat late. Mirrors
// REEL_IMG in useNextPackItems (which is q:75 — the reel blurs, the winner
// card is shown sharp, so they intentionally differ and warm separate URLs).
export const WINNER_IMG = { width: 232, height: 367, quality: 85 } as const;

/** Warm the CDN cache for one winner card image (no-op for empty/invalid). */
export function preloadWinnerImage(url: string | null | undefined): void {
  const resolved = compressedImageUrl({ url, ...WINNER_IMG });
  if (!resolved) return;
  const img = new window.Image();
  img.src = resolved;
}

/** Warm every item's winner image — used to prefetch a whole order up front. */
export function preloadWinnerImages(
  items: ReadonlyArray<{ imageUrl: string | null }>,
): void {
  for (const it of items) preloadWinnerImage(it.imageUrl);
}
